import React from 'react';
import styles from './stages.module.scss';
/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';
import { StoreType } from '../interfaces/store_types';

interface InitButtonProps {
  action: () => void;
  store: StoreType;
}

export const InitButton: React.FC<InitButtonProps> = ({ action, store }) => {
  const { t } = useTranslation();

  return (
    <button className={styles.initButton} onClick={action} id={styles[store]}>
      {tr(t, 'proceed_to_purchase')}
    </button>
  );
};
